import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, CardBody, CardText, CardTitle} from 'reactstrap';

import GetMissions from '../../../components/GetMissions/GetMissions.jsx';
import HowToGetMissions from '../../../components/HowToGetMissions/HowToGetMissions.jsx';
import Header from '../../../components/Header/Header.jsx';
import Landing from '../Landing.jsx';
import LinkAs from '../../../components/LinkAs/LinkAs.jsx';

import {generate} from '../../../routes.js';
import {isUserFreelance} from '../../../../shared/services/userService.js';

import header from './images/header-generic-hr.png?size=600';

import './LandingFreelance.scss';

const universes = [
  {name: 'Achats et approvisionnement', code: 'purchase', keywords: ['Directeur Achat', 'Responsable Achat', 'Acheteur indirect', 'Acheteur production', 'Acheteur public', 'Gestionnaire d\'entente...']},
  {name: 'Finance', code: 'finance', keywords: ['DAF / RAF', 'Trésorier', 'Contrôleur de gestion', 'Consolideur', 'Comptabilité...']},
  {name: 'Ressources Humaines', code: 'hr', keywords: ['DRH / RRH', 'Responsable paie', 'Chargé projet SIRH', 'Chargé de recrutement...']},
]

class LandingFreelance extends PureComponent {
  render() {
    const headerBrief = <p>
      Rencontrez-nous et <strong>parlons de votre projet !</strong> Twineeds vous recontacte ensuite par téléphone, SMS
      ou email afin de <strong>vous proposer les mandats qui vous correspondent</strong>.
    </p>;

    const headerCtas = <Fragment>
      <LinkAs
        className="btn btn-primary"
        notConnected={generate({name: 'register-freelance'})}
        freelance={generate({name: 'offers'})}
      >
        {isUserFreelance ? 'Consulter les mandats' : 'Nous rencontrer'}
      </LinkAs>
    </Fragment>;

    return <Landing
      className="landing-freelance"
      metaDescription="Recevez des opportunités de mandat en interim management et management de transition dans les secteurs des Achats, Ressources Humaines et Finance"
      metaTitle="Mandats pour consultants indépendants"
    >
      <Header
        brief={headerBrief}
        ctas={headerCtas}
        imageAlt={''}
        imageSrc={header.src}
        title="Recevez des mandats directement sur votre mobile !"
      />

      <div className="bg-light">
        <section id="universes" className="container text-center py-5">
          <h2 className="mb-4">Les métiers adressés</h2>
          <ul className="row card-deck pl-0 mb-0">
            {universes.map((universe) => (
              <li className="d-flex flex-column align-items-center col-xs-12 col-md-4 mb-4 mb-md-0" key={universe.code}>
                <Card className="mb-2 w-100">
                  <CardBody>
                    <CardTitle tag="h3">{universe.name}</CardTitle>
                    <CardText className="pl-0" tag="ul">
                      {universe.keywords.map((keyword, index) => <li key={index}>{keyword}</li>)}
                    </CardText>
                  </CardBody>
                </Card>
                <Link className="btn btn-primary" to={generate({name: 'landing-freelance-' + universe.code})}>
                  En savoir plus
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <HowToGetMissions/>

      <GetMissions/>
    </Landing>;
  }
}

export default connect(
  state => ({
    isUserFreelance: isUserFreelance(state.currentUser.user)
  })
)(LandingFreelance);
